// Shared logo component - reads from localStorage
// Usage: <CompanyLogo size="sm" /> or <CompanyLogo size="lg" />

export function CompanyLogo({ size = 'md', style = {} }) {
  const logoUrl = localStorage.getItem('firm_logo_url')
  const firmName = localStorage.getItem('firm_name') || 'CCIS Singapore Pte Ltd'

  const heights = { sm: 28, md: 36, lg: 52 }
  const h = heights[size] || 36

  if (!logoUrl) return (
    <div style={{ fontWeight: 700, fontSize: size === 'lg' ? 18 : size === 'sm' ? 13 : 15, color: '#006363', ...style }}>
      {firmName}
    </div>
  )

  return (
    <img
      src={logoUrl}
      alt={firmName}
      style={{
        height: h,
        maxWidth: h * 5, // max aspect ratio 5:1
        objectFit: 'contain',
        display: 'block',
        ...style
      }}
    />
  )
}

export function PageHeader({ size = 'md' }) {
  const firmName = localStorage.getItem('firm_name') || 'CCIS Singapore Pte Ltd'
  const logoUrl = localStorage.getItem('firm_logo_url')

  return (
    <div style={{ marginBottom: 24 }}>
      {logoUrl ? (
        <img src={logoUrl} alt={firmName}
          style={{ height: 44, maxWidth: 200, objectFit: 'contain', marginBottom: 10, display: 'block' }} />
      ) : (
        <div style={{ fontSize: 12, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 }}>
          {firmName}
        </div>
      )}
    </div>
  )
}
